import EulaActions from '../../actions/EulaActions';
import EulaStore from '../../stores/EulaStore';
import LoadScreen from '../../components/loadScreen/LoadScreen';
import PropTypes from 'prop-types';
import React from 'react';
import {connectToStores} from 'epic-alt-utils/index';

/*eslint-disable jsx-a11y/anchor-is-valid */
/**
 * FAQ View
 */
@connectToStores
class EulaView extends React.Component {
    static propTypes = {
        eulaStore: PropTypes.object,
        location: PropTypes.object
    };

    static getStores() {
        return [EulaStore];
    }

    static getPropsFromStores() {
        return {
            eulaStore: EulaStore.getState()
        };
    }

    static getInitialActions() {
        return [EulaActions.fetchEula];
    }

    render() {
        const {eulaStore} = this.props;
        const eula = eulaStore.eula;
        let eulaContainer = null;
        if (eula) {
            eulaContainer = (
                <div className="eula-container">
                    <h1 className="eula-title">
                        {eula.title}
                    </h1>
                    { //eslint-disable-next-line react/no-danger
                    }<div className="eula-body" dangerouslySetInnerHTML={{__html: eula.body}} />
                </div>
            );
        }
        return (
            <div className="eula-view-container">
                {eulaContainer}
                <LoadScreen show={eulaStore.loading} />
            </div>
        );
    }
}

export default EulaView;
